/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Cmp_Mobile_PrInputs */

const en_fc_cmp_mobile_pr = /** @type {(inputs: Fc_Cmp_Mobile_PrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iPhone and Android`)
};

/**
* | output |
* | --- |
* | "iPhone and Android" |
*
* @param {Fc_Cmp_Mobile_PrInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_cmp_mobile_pr = /** @type {((inputs?: Fc_Cmp_Mobile_PrInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Cmp_Mobile_PrInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_cmp_mobile_pr(inputs)
});
export { fc_cmp_mobile_pr as "fc.cmp.mobile.pr" }